module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/ohio-university-150cda255898fa9bcddae03bf1b67d89.svg";